import { combineReducers } from "redux"
import {
    ContentfulReducer,
    ContentfulState,
    ContentfulAction
} from "./ContentfulReducer"

export const ExternalReducer = combineReducers({
    contentful: ContentfulReducer
})

export interface ExternalState {
    contentful: ContentfulState
}

export type ExternalAction = ContentfulAction
